import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import { SortDirection } from '@core/types';

@Directive({
  selector: '[appSortable]',
  standalone: true,
})
export class SortableDirective {
  @Input('appSortable') sortable!: string;
  @Input() direction: SortDirection = '';
  @Output() sortChange = new EventEmitter<{ column: string; direction: SortDirection }>();

  @HostBinding('class.asc') get isAscending() {
    return this.direction === 'asc';
  }

  @HostBinding('class.desc') get isDescending() {
    return this.direction === 'desc';
  }

  @HostListener('click') changeSort() {
    this.direction = this.direction === 'asc' ? 'desc' : this.direction === 'desc' ? '' : 'asc';
    this.sortChange.emit({ column: this.sortable, direction: this.direction });
  }
}
